import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";

import Loader from "../../Loader.jsx";
import Dialog from "../../Dialog.jsx";
import { API_CONFIG } from "../../../../Config/config-env.js";
import {
  enviarMail,
  enviarWsp,
  getDays,
  getMonths,
  getYears,
  cancelaReserva,
  validateForm,
  getDatosCliente,
  registraReserva,
  getDiasByIdConsultorioYServicio,
  getClienteByCI,
  getDiasParaReservar,
  getConsultoriosByIdCiudad,
  getCiudades,
  getMensajes,
} from "../../functions.js";
import {
  toast,
  ToastContainer,
  MDBFormInline,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBStepper,
  MDBStep,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon,
} from "mdbreact";

class Booking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      whatsImg:
        "iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAARRSURBVDhPtVVdbFRVEP7O/enudrd3l62trQW0NhKlT9TEICQQ8OfBRhoTYwym0eCLGmtiY40PAvKgBo1EIrFqJD4IapQGap8QMCTog6XRBKkl4acqrW3pj/u/9/cc50w3GIyPOrOzd3fud78zM+fMXKFIiijjBH7AuLqEPP3TIkkBwb9vFFW7AgapFkek0IkO3I/1SNNvUZRltVsNomqE8FCtkf0tIamPgLyKl7BI62ATnbhOr8nrEEdcmtgjnoMYCk+o4+Yoyn6RHxK16ALSqvLQajThTtGOm0QGLtFfkVO4qH5HpCLUizhjtSjSZJ2DLdE6iF3uATUZm0Ho+kxYUS6DUqIeT9k92Gh2EbmLgipxhFkjjVm1iE+CoxiLxhnriCRfrbiNNr8Jor/ylpqJLSCqRhSJh0aRZsDeRD9c5eNj/wgmoiscpUlpNokseuwt6LY34yP/K8Ye9U9yXY2YicYgXav0fyyir/i6mo0tInADhFSnwdQuvpGTBbxY2cvRZoUDS1hct0CF0Kel296EgcQOxu6svIez4Xk4sRSygQNDKokwCpEPiwxspvS0DRTfRqfowLvJV5BWKbiRCxlFMKVARqZwrHoKI95ptufj2yEiwI/olEgJIyJgEIbsfKhuE4bcb9imgjlsj3XjbmstttrrUQhKtHh03ZIyjs/KI2yNRgZrjQ6UwwoiGREpfXmRD0claZMyOOv+zGZGAktRgdO76P8KFSnOKKBo9FVQxNPBtWUL57DGvA2VsMr3DL2qBppyec8KYYnNlhY+LR7jZlhltJCviCL5i0EZS0GenqGmoGC0VVQVCRVjn+aj9EOqlcSfQQERqY5Wm47sF/cSdi7uxzPO4xhIP43VRiveaXwZvcmHub4aoy1L6c+G8+zTfEZI6SsinQ8WMeFdxgOJDWy6JEmVwHDhFPrn3sS2+q34vGUf7o2vQ1+mF7Q+bjdWst1sNmK0co5KZnBNLb1R+ijpaA/lvsb+1le5DG1GM62+wJ11vHgGY5XzeDC1Ee32Spwuj+I3bxqDLa8x9rvKGMYrF5GJp5nLCmVIfazrE/CEmQ5mGThZvYqUmaTNysEUBuajRXy48AVKsoKsmcYHbXuw2r6Fsc9O7YatTE49JC5LSdpVPYlCH5uT9yBRGxIHV72BzvgdOFMaw0jhW8wE86g34uhKdOLJ7CM8tR6bfIGxU94sHDMFLiXp/9OmvZMvqZ9wAXbVwOH2ffCkzzfOVS9gwr2Mben7cFeig4aJyf6lMIfh/EkcXDgCmsXsazCSyxEmTKxRt0K8P3dYDYovYc5JOFYKV/0ZBrrSgxCCyZrsLFaYDvl8XKPNK8sqUkRk0zzQogn1x2qJY4fsgaCeV49O9uGPhgV4eRcWTW8tmlCLfkAPZDofPG8toQfgP6pm0OINFppLGQy1HwC/o3QHHcoN4/vyj8h5+WXgjW+Vf5cad7quARtSXXgi3YMVtoO/AIBLUlaXZU2gAAAAAElFTkSuQmCC",
      zoomImg:
        "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",
      collapseID: "collapse1",
      urlBack: "#",
      id_consultorio_original: -1,
      id_ciudad_original: -1,
      id_beneficiario: 0,
      formActivePanel1: 1,
      formActivePanel1Changed: false,
      isExecuting: false,
      showReservationType: true,
      showReservationForm: false,
      showReservationSucc: false,
      showEditReservationSucc: false,
      ciudades: [],
      modal1: false,
      tipoReserva: "",
      email_cliente: "",
      tipoReserva_original: "",
      Id_afiliado_original: "",
      ci_afiliado_original: "",
      Tipo_doc_afiliado_original: "",
      consultorios: [],
      radioGenero: 0,
      lock_ci: true,
      radioTipoReunionVirtual: 0,
      buttonsModalBack: [
        {
          buttonAction: this.goBackTrue,
          buttonId: 1,
          buttonClass: "btn btn-danger btn-sm",
          buttonName: "Volver al panel de revervas",
        },
      ],
      validation: [
        {
          name: "ci_cliente",
          label: "Carnet de Identidad",
          invalid: false,
          type: "number",
          notRequired: true,
        },
        {
          name: "nombre_cliente",
          label: "Primer Nombre",
          invalid: false,
          type: "text",
        },

        {
          name: "apellido_paterno",
          label: "Apellido Paterno",
          invalid: false,
          type: "text",
        },
        {
          name: "telefono_cliente",
          label:
            "Numero de Celular(Es necesario para enviarle las notificaciones)",
          invalid: false,
          type: "phone",
        },
        {
          name: "email_cliente",
          label: "Email",
          invalid: false,
          type: "email",
          notRequired: true,
        },
        {
          name: "day",
          label: "Dia de Nacimiento",
          invalid: false,
          type: "text",
        },
        {
          name: "month",
          label: "Mes de Nacimiento",
          invalid: false,
          type: "text",
        },
        {
          name: "year",
          label: "A\u00F1o de Nacimiento",
          invalid: false,
          type: "number",
        },
      ],
      validation2: [
        { name: "id_ciudad", label: "Ciudad", invalid: false, type: "select" },
        {
          name: "id_consultorio",
          label: "Consultorio",
          invalid: false,
          type: "select",
        },
      ],

      Beneficiarios: [],
      ci_cliente: "",
      TipoDoc: "C",
      nombre_cliente: "",
      nombre_cliente2: "",
      apellido_paterno: "",
      fecha_reserva_original: "",
      fechaSelected: "",
      apellido_materno: "",
      telefono_cliente: "",
      Tipo: "",
      Id_afiliado: "",
      ci_afiliado: "",
      Tipo_doc_afiliado: "",
      ciudad: "",
      consultorio: "",
      day: "",
      month: "",
      year: "",
      id_consultorio: "",
      id_ciudad: "",
      tmp_id_cons: -1,
      horas_libres: [],
      dias: [],
      hora_larga: "",
      from_fecha: 0,
      to_fecha: 6,
      hora_original: "",
      id_hora: 0,
      id_hora_original: 0,
      tipo_transaccion: "Reservar y Pagar",
      estado_formulario: "registrar",
      zona: "",
      direccion: "",
      latitud: "",
      longitud: "",
      hora: "",
      nombre_producto: "",
      mensajes_inferiores: [],
      mensaje_soporte_tecnico: "",
      paymentKey: "null",
      disabledServiceType: false,
      v_days: [],
      v_months: [],
      id_servicio: null,
      v_years: [],
      goBack: false,
      dias_max_reserva: 0,
      mensaje_seleccione_fechahora: "",
      cis_reservados: [],
      serviceType: 0,
      planCode: "",
    };
  }
  //http://localhost:2000/patient/booking/presencial/PPAB0039/9935861/PPCE0062?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub21icmVfY2xpZW50ZSI6IlBFRFJPIiwiYXBlbGxpZG9fcGF0ZXJubyI6Ik1FTkRPWkEiLCJhcGVsbGlkb19tYXRlcm5vIjoiQ0hPUVVFIiwiY2lfY2xpZW50ZSI6OTkzNTg2MSwiZW1haWxfY2xpZW50ZSI6IiIsInRlbGVmb25vX2NsaWVudGUiOiI2MjQ2ODQwMCIsIkdlbmVybyI6MSwibm9tYnJlX3BsYW4iOiJQUENFMDA2MiIsInBsYW4iOiJQbGFuIEJpZW5lc3RhciB5IFByb3RlY2Npw7NuIiwic2VydmljaW8iOiJDb25zdWx0YSBNw6lkaWNhIEdlbmVyYWwgQ29sZWN0aXZvIiwibm9tYnJlX3NlcnZpY2lvIjoiQ29uc3VsdGEgTcOpZGljYSBHZW5lcmFsIENvbGVjdGl2byIsImlkX2NvbnN1bHRvcmlvIjoiNDUiLCJ0aXBvX3Jlc2VydmEiOiJwcmVzZW5jaWFsIiwiZmVjaGFfcmVnaXN0cm8iOjE3MTE5OTQxNDE4OTgsImNvbnN1bHRvcmlvIjoiT0JSQUpFUyBOVUVWTyIsImNpdWRhZCI6IkxhIFBheiIsImRpcmVjY2lvbiI6IkF2LiBIZXJuYW5kbyBTaWxlcyBlbnRyZSBDYWxsZSAxMiB5IDEzLiIsInpvbmEiOiJab25hIE9icmFqZXMiLCJsYXRpdHVkIjotMTYuNTI3ODQwNzg1NzU2NzcsImxvbmdpdHVkIjotNjguMTA1MDY1NTUzNTkzNzYsImZlY2hhX3Jlc2VydmEiOiIyMDI0LTA0LTAyIiwiaG9yYV9yZXNlcnZhIjoiMDk6NDAgLSAxMDowMCIsIkZlY2hhTmFjaSI6IjE5OTgwODMwIiwiaWF0IjoxNzExOTk0MTQxLCJleHAiOjE3NDM1MzAxNDF9.TLwh8dO-oUeUeFAdZRv2nppt8JggigdT7zCX66tnLeo

  componentDidMount = async () => {
    this.setState({ isExecuting: true, lock_ci: false });

    var serviceId = this.props.match.params.serviceId;
    var serviceType = this.props.match.params.serviceType;
    var customerCI = this.props.match.params.customerCI;

    var planCode = this.props.match.params.planCode;

    var token = this.props.location.search || "";
    token = token.substr(7, token.length);
    //console.log(token);
    var estado_formulario = "registrar";
    var tipo_transaccion = "Reservar";
    if (token.length > 0) {
      //console.log("UPDATE")
      tipo_transaccion = "Cambiar reserva";
      estado_formulario = "editar";
    }

    if (serviceType === "virtual") {
      this.setState({
        ...this.state,
        isExecuting: true,
        showReservationType: false,
        showReservationForm: true,
        tipoReserva: "virtual",
        id_servicio: serviceId,
        id_ciudad: -1,
        paso2: 1,
        paso3: 2,
        disabledServiceType: true,
        formActivePanel1: 2,
        serviceType: serviceType,
        customerCI: customerCI,
        planCode: planCode,
      });
    } else if (serviceType === "presencial") {
      this.setState({
        ...this.state,
        isExecuting: true,
        showReservationType: false,
        showReservationForm: true,
        tipoReserva: "presencial",
        id_servicio: serviceId,
        paso2: 2,
        paso3: 3,
        formActivePanel1: 1,
        id_ciudad: "",
        disabledServiceType: true,
        id_consultorio: "",
        serviceType: serviceType,
        customerCI: customerCI,
        planCode: planCode,
      });

      var respCiudades = await getCiudades();
      this.setState({
        ...this.state,

        ciudades: respCiudades.ciudades,
      });
    }
    var respMensajes = await getMensajes();
    var respDias = await getDiasParaReservar();

    this.setState({
      ...this.state,
      desde: respDias.desde,
      hasta: respDias.hasta,
      dias_max_reserva: respDias.cantidad_dias,
      horas_cambiar_cita: respMensajes.horas_cambiar_cita,
      horas_cancelar_cita: respMensajes.horas_cancelar_cita,
      horas_minino_reserva: respMensajes.horas_minino_reserva,
    });

    var tmp_id_cons = null;
    var nombre_producto;
    var Beneficiarios = [];
    var urlBack = "#";
    var cis_reservados = [];
    //   console.log(  document.referrer, window.document.referrer)

    urlBack = "/patient/dashboard/" + customerCI;

    var forcedKey = this.props.match.params.forcedKey;
    if (forcedKey) {
      urlBack += "#atenciones?id_producto_cliente=" + forcedKey;
    }
    /*
      urlBack = "/HomeServices";
      var respToken = await generateTempToken(serviceId);
      token = respToken.tempToken;
      nombre_producto = respToken.datos.nombre_producto;
      tipo_transaccion = "Reservar y Pagar";
      estado_formulario = "registrar";
*/

    if (serviceType === "virtual") {
      var resp = await getDiasByIdConsultorioYServicio(
        -1,
        this.state.desde,
        this.state.hasta,
        this.state.dias_max_reserva,
        this.state.serviceType,
        this.state.id_servicio,
        this.state.customerCI,
        this.state.horas_minino_reserva
      );
      //var resp2 = await getHorasLibresByIdConsultorio(-1, resp.dias[0].fecha, this.state.hora, token,  this.state.id_hora_original)

      this.setState({
        ...this.state,
        dias: resp.dias,
        //horas_libres   : resp2.horas_libres,
        //fechaSelected  : resp.dias[0].fecha,
        id_consultorio: -1,
        zona: "",
        direccion: "",
        latitud: "",
        longitud: "",
        consultorio: "",
        id_hora: 0,
        hora: "",
      });
    }

    let respCliente = {};
    let nombreplan = "";
    let nombreServicio = "";
    if (customerCI && planCode) {
      // console.log("planCode", planCode, customerCI, serviceId);
      let respReservas = await getDatosCliente(customerCI, [], planCode);
      //tipo_transaccion = "Reservar";
      if (respReservas.Estado === "E") {
        for (let r in respReservas.productos) {
          let plan = respReservas.productos[r];

          if (plan.id_producto === planCode) {
            for (let p in plan.prestaciones) {
              let prest = plan.prestaciones[p];
              if (prest.id_servicio === serviceId) {
                // console.log("aqui es", prest);
                // console.log("ES ESTA", plan);
                respCliente = plan;
                nombreplan = plan.nombre_producto;
                Beneficiarios = plan.Beneficiarios;
                nombreServicio = prest.servicio;
                for (let i in Beneficiarios) {
                  cis_reservados.push(Beneficiarios[i].ci_cliente + "");
                }
              }
            }
          }
        }
      }
    }

    var v_days = getDays();
    var v_months = getMonths();
    var v_years = getYears();

    let year = "";
    let month = "";
    let day = "";
    if (respCliente.FechaNaci) {
      let f = respCliente.FechaNaci.split("-");
      year = f[0];
      month = f[1];
      day = f[2];
    }
    //console.log("fin",tipo_transaccion)
    this.setState({
      ...this.state,
      nombreplan: nombreplan,
      nombreServicio: nombreServicio,
      ci_cliente: respCliente.ci_cliente,
      ci_afiliado: respCliente.ci_cliente,
      nombre_cliente: respCliente.nombre_cliente,
      nombre_cliente2: respCliente.nombre_cliente2 || "",
      apellido_paterno: respCliente.apellido_paterno,
      apellido_materno: respCliente.apellido_materno,
      radioGenero: respCliente.Genero,
      telefono_cliente: respCliente.telefono_cliente,
      email_cliente: respCliente.email_cliente || "",
      year: year,
      month: month,
      day: day,
      Tipo: respCliente.Tipo,

      desde: respDias.desde,
      hasta: respDias.hasta,
      cis_reservados: cis_reservados,
      //dias_max_reserva:respDias.cantidad_dias,
      Beneficiarios: Beneficiarios,
      //consultorios:respConsultorios.consultorios,
      isExecuting: false,
      token: token,
      tipo_transaccion: tipo_transaccion,
      estado_formulario: estado_formulario,
      nombre_producto: nombre_producto,
      mensajes_inferiores: respMensajes.mensajes_inferiores,
      mensaje_alta_reserva: respMensajes.mensaje_alta_reserva,
      mensaje_cambio_reserva: respMensajes.mensaje_cambio_reserva,
      mensaje_cancelacion_reserva: respMensajes.mensaje_cancelacion_reserva,
      mensaje_reserva_existente: respMensajes.mensaje_reserva_existente,
      mensaje_tiempo_cancelacion: respMensajes.mensaje_tiempo_cancelacion,
      mensaje_tiempo_cambio: respMensajes.mensaje_tiempo_cambio,
      mensaje_elija_reverva: respMensajes.mensaje_elija_reverva,
      mensaje_confirmar_fecha: respMensajes.mensaje_confirmar_fecha,
      mensaje_soporte_tecnico: respMensajes.mensaje_soporte_tecnico,
      mensaje_confidencialidad: respMensajes.mensaje_confidencialidad,
      mensaje_seleccione_fechahora: respMensajes.mensaje_seleccione_fechahora,
      v_days: v_days,
      v_months: v_months,
      v_years: v_years,
      urlBack: urlBack,
    });
  };

  onClickRadio = (nr) => () => {
    this.setState({
      radioGenero: nr,
    });
  };
  onClickRadio2 = (nr) => () => {
    /*
  	if (this.state.radioTipoReunionVirtual_orig ===nr){
  		console.log("vuelve")
  		this.setState({
          id_consultorio_original: -1
      });
  	}else{
  		console.log("cambia")
  		this.setState({
          id_consultorio_original: -2
      });
  		
  	} */
    this.setState({
      radioTipoReunionVirtual: nr,
    });
  };

  goBackTrue = (event) => {
    this.setState({ goBack: true });
  };
  swapFormActive = (a) => (param) => (e) => {
    this.setState({
      ["formActivePanel" + a]: param,
      ["formActivePanel" + a + "Changed"]: true,
    });
  };

  handleNextPrevClick = (a) => (param) => (e) => {
    var isValid = true;
    var isValid2 = true;

    if (param === 2) {
      var respVal2 = validateForm(this.state.validation2, this.state, toast);
      this.setState({ ...this.state, validation2: respVal2.validation });
      isValid2 = respVal2.isValid;
    }

    if (param === 3) {
      if (this.state.id_hora === 0) {
        toast.warning("Debe elegir una hora v\u00E1lida", {
          closeButton: true,
        });
        isValid2 = false;
      } else {
        //caso 1 presencial
        if (this.state.tipoReserva === this.state.tipoReserva_original) {
          if (this.state.tipoReserva === "presencial") {
            if (this.state.id_hora === this.state.id_hora_original) {
              toast.warning(
                "Debe elegir una nueva hora, Ud. ya tiene reservada la fecha:" +
                  this.state.fecha_reserva_original +
                  " a horas:" +
                  this.state.hora_original,
                { closeButton: true }
              );
              isValid2 = false;
            }
          }
          if (this.state.tipoReserva === "virtual") {
            if (
              this.state.hora === this.state.hora_original &&
              this.state.fechaSelected === this.state.fecha_reserva_original
            ) {
              toast.warning(
                "Debe elegir una nueva hora. Ud. ya tiene reservada la fecha:" +
                  this.state.fecha_reserva_original +
                  " a horas:" +
                  this.state.hora_original,
                { closeButton: true }
              );
              isValid2 = false;
            }
          }
        }
      }
    }
    if (isValid && isValid2) {
      this.setState({
        ["formActivePanel" + a]: param,
        ["formActivePanel" + a + "Changed"]: true,
      });
    }
  };

  calculateAutofocus = (a) => {
    if (this.state["formActivePanel" + a + "Changed"]) {
      return true;
    }
  };

  setPatientData = (event) => {
    var lock_ci = false;
    var field_value = this.state.id_cliente_cur;

    for (var i in this.state.Beneficiarios) {
      if (this.state.Beneficiarios[i].id_cliente == field_value) {
        if (this.state.Beneficiarios[i].ci_cliente != "") {
          lock_ci = true;
        }

        var id_cliente = this.state.Beneficiarios[i].id_cliente;
        var ci_cliente = this.state.Beneficiarios[i].ci_cliente;
        var bloquear_datos = true;
        var nombre_cliente = this.state.Beneficiarios[i].nombre_cliente;
        var nombre_cliente2 = this.state.Beneficiarios[i].nombre_cliente2 || "";
        var TipoDoc = this.state.Beneficiarios[i].TipoDoc;
        var apellido_paterno = this.state.Beneficiarios[i].apellido_paterno;
        var apellido_materno = this.state.Beneficiarios[i].apellido_materno;
        var radioGenero = this.state.Beneficiarios[i].radioGenero;
        var telefono_cliente = this.state.Beneficiarios[i].telefono_cliente;
        var email_cliente = this.state.Beneficiarios[i].email_cliente;
        var FechaNaci = this.state.Beneficiarios[i].FechaNaci;
        var Tipo = this.state.Beneficiarios[i].Tipo;
        var Id_afiliado = this.state.Beneficiarios[i].Id_afiliado;
        var ci_afiliado = this.state.Beneficiarios[i].ci_afiliado;
        var Tipo_doc_afiliado = this.state.Beneficiarios[i].Tipo_doc_afiliado;
      }
    }
    if (this.state.Id_afiliado == field_value) {
      Id_afiliado = "";
      ci_afiliado = "";
      Tipo_doc_afiliado = "";
    } else {
      Id_afiliado = this.state.Id_afiliado_original;
      ci_afiliado = this.state.ci_afiliado_original;
      Tipo_doc_afiliado = this.state.Tipo_doc_afiliado_original;
    }
    var validation = [
      {
        name: "ci_cliente",
        label: "Carnet de Identidad",
        invalid: false,
        type: "number",
        notRequired: true,
      },
      {
        name: "nombre_cliente",
        label: "Primer Nombre",
        invalid: false,
        type: "text",
      },

      {
        name: "apellido_paterno",
        label: "Apellido Paterno",
        invalid: false,
        type: "text",
      },
      {
        name: "telefono_cliente",
        label:
          "Numero de Celular(Es necesario para enviarle las notificaciones)",
        invalid: false,
        type: "phone",
      },
      {
        name: "email_cliente",
        label: "Email",
        invalid: false,
        type: "email",
        notRequired: true,
      },
      { name: "day", label: "Dia de Nacimiento", invalid: false, type: "text" },
      {
        name: "month",
        label: "Mes de Nacimiento",
        invalid: false,
        type: "text",
      },
      {
        name: "year",
        label: "A\u00F1o de Nacimiento",
        invalid: false,
        type: "number",
      },
    ];
    this.setState({ ...this.state, validation: validation });
    this.setState({
      ...this.state,
      lock_ci: lock_ci,
      look_agregar: false,
      id_cliente: id_cliente,
      ci_cliente: ci_cliente,
      bloquear_datos: bloquear_datos,
      nombre_cliente: nombre_cliente,
      nombre_cliente2: nombre_cliente2,
      TipoDoc: TipoDoc,
      apellido_paterno: apellido_paterno,
      apellido_materno: apellido_materno,
      radioGenero: radioGenero,
      telefono_cliente: telefono_cliente,
      email_cliente: email_cliente,
      year: FechaNaci ? FechaNaci.substr(0, 4) : "",
      month: FechaNaci ? FechaNaci.substr(4, 2) : "",
      day: FechaNaci ? FechaNaci.substr(6, 2) : "",
      Tipo: Tipo,
      Id_afiliado: Id_afiliado,
      ci_afiliado: ci_afiliado,
      Tipo_doc_afiliado: Tipo_doc_afiliado,
    });
  };

  changeHandler = async (event) => {
    var field_value = event.target.value;
    var field_name = event.target.name;

    var Id_afiliado;
    var ci_afiliado;
    var Tipo_doc_afiliado;
    var validation;
    var ciudad;
    var respVal = validateForm(
      this.state.validation,
      this.state,
      toast,
      field_name,
      field_value
    );
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value,
      validation: respVal.validation,
    });

    if (field_name === "ci_cliente") {
      if (field_value.length >= 5 && field_value.length <= 12) {
        if (this.state.cis_reservados.indexOf(field_value) >= 0) {
          this.setState({ ...this.state, ci_cliente: "", id_cliente: "" });
        } else {
          var resp = await getClienteByCI(field_value);

          if (resp.bloquear_datos) {
            validation = [
              {
                name: "ci_cliente",
                label: "Carnet de Identidad",
                invalid: false,
                type: "number",
                notRequired: true,
              },
              {
                name: "nombre_cliente",
                label: "Primer Nombre",
                invalid: false,
                type: "text",
              },

              {
                name: "apellido_paterno",
                label: "Apellido Paterno",
                invalid: false,
                type: "text",
              },
              {
                name: "telefono_cliente",
                label:
                  "Numero de Celular(Es necesario para enviarle las notificaciones)",
                invalid: false,
                type: "phone",
              },
              {
                name: "email_cliente",
                label: "Email",
                invalid: false,
                type: "email",
                notRequired: true,
              },
              {
                name: "day",
                label: "Dia de Nacimiento",
                invalid: false,
                type: "text",
              },
              {
                name: "month",
                label: "Mes de Nacimiento",
                invalid: false,
                type: "text",
              },
              {
                name: "year",
                label: "A\u00F1o de Nacimiento",
                invalid: false,
                type: "number",
              },
            ];
            this.setState({ ...this.state, validation: validation });
          }
          if (this.state.Id_afiliado_original !== "") {
            Id_afiliado = this.state.Id_afiliado_original;
            ci_afiliado = this.state.ci_afiliado_original;
            Tipo_doc_afiliado = this.state.Tipo_doc_afiliado_original;
          } else {
            Id_afiliado = resp.Id_afiliado;
            ci_afiliado = resp.ci_afiliado;
            Tipo_doc_afiliado = resp.Tipo_doc;
          }

          if (this.state.Id_afiliado === resp.id_cliente) {
            Id_afiliado = "";
            ci_afiliado = "";
            Tipo_doc_afiliado = "";
          }

          this.setState({
            ...this.state,
            bloquear_datos: resp.bloquear_datos,
            id_cliente: resp.id_cliente,
            nombre_cliente: resp.nombre_cliente,
            nombre_cliente2: resp.nombre_cliente2 || "",
            TipoDoc: resp.TipoDoc,
            apellido_paterno: resp.apellido_paterno,
            apellido_materno: resp.apellido_materno,
            radioGenero: resp.radioGenero,
            telefono_cliente: resp.telefono_cliente,
            email_cliente: resp.email_cliente,
            year: resp.FechaNaci ? resp.FechaNaci.substr(0, 4) : "",
            month: resp.FechaNaci ? resp.FechaNaci.substr(4, 2) : "",
            day: resp.FechaNaci ? resp.FechaNaci.substr(6, 2) : "",
            Tipo: resp.Tipo,
            Id_afiliado: Id_afiliado,
            ci_afiliado: ci_afiliado,
            Tipo_doc_afiliado: Tipo_doc_afiliado,
          });
        }
      } else if (field_value.length === 0) {
        validation = [
          {
            name: "ci_cliente",
            label: "Carnet de Identidad",
            invalid: false,
            type: "number",
            notRequired: true,
          },
          {
            name: "nombre_cliente",
            label: "Primer Nombre",
            invalid: false,
            type: "text",
          },

          {
            name: "apellido_paterno",
            label: "Apellido Paterno",
            invalid: false,
            type: "text",
          },
          {
            name: "telefono_cliente",
            label:
              "Numero de Celular(Es necesario para enviarle las notificaciones)",
            invalid: false,
            type: "phone",
          },
          {
            name: "email_cliente",
            label: "Email",
            invalid: false,
            type: "email",
            notRequired: true,
          },
          {
            name: "day",
            label: "Dia de Nacimiento",
            invalid: false,
            type: "text",
          },
          {
            name: "month",
            label: "Mes de Nacimiento",
            invalid: false,
            type: "text",
          },
          {
            name: "year",
            label: "A\u00F1o de Nacimiento",
            invalid: false,
            type: "number",
          },
        ];
        this.setState({ ...this.state, validation: validation });

        if (this.state.Id_afiliado_original !== "") {
          Id_afiliado = this.state.Id_afiliado_original;
          ci_afiliado = this.state.ci_afiliado_original;
          Tipo_doc_afiliado = this.state.Tipo_doc_afiliado_original;
        }
        this.setState({
          ...this.state,
          bloquear_datos: "",
          nombre_cliente: "",
          nombre_cliente2: "",
          ci_cliente: "",
          id_cliente: "",
          TipoDoc: "",
          apellido_paterno: "",
          apellido_materno: "",
          radioGenero: 0,
          telefono_cliente: "",
          email_cliente: "",
          year: "",
          month: "",
          day: "",
          Tipo: "2",
          Id_afiliado: Id_afiliado,
          ci_afiliado: ci_afiliado,
          Tipo_doc_afiliado: Tipo_doc_afiliado,
        });
      }
    } else if (field_name === "id_ciudad") {
      if (field_value !== "") {
        for (var key in this.state.ciudades) {
          if (this.state.ciudades[key].value === field_value) {
            ciudad = this.state.ciudades[key].text;
          }
        }
        this.setState({
          ...this.state,
          isExecuting: true,
          hora: "",
          fechaSelected: "",
          horas_libres: [],
          id_consultorio: "",
          id_ciudad: field_value,
        });
        let resp = await getConsultoriosByIdCiudad(field_value);
        this.setState({
          ...this.state,
          consultorios: resp.consultorios,
          consultorio: "",
          horas_libres: [],
          dias: [],
          id_hora: 0,
          id_ciudad: field_name,
          hora: "",
          fechaSelected: "",
          ciudad: ciudad,
          isExecuting: false,
        });
      } else {
        var consultorios = [{ text: "Elija un consultorio", value: "" }];
        this.setState({
          ...this.state,
          fechaSelected: "",
          hora: "",
          consultorios: consultorios,
          consultorio: "",
          horas_libres: [],
          id_consultorio: "",
          id_ciudad: "",
        });
      }
    } else if (field_name === "id_consultorio") {
      let respVal = validateForm(
        this.state.validation2,
        toast,
        field_name,
        field_value
      );
      this.setState({ ...this.state, validation2: respVal.validation });

      if (field_value !== "") {
        var zona, direccion, latitud, longitud, consultorio;
        this.setState({
          ...this.state,
          hora: "",
          fechaSelected: "",
          horas_libres: [],
          id_consultorio: field_value,
          isExecuting: true,
        });

        let resp = await getDiasByIdConsultorioYServicio(
          field_value,
          this.state.desde,
          this.state.hasta,
          this.state.dias_max_reserva,
          this.state.serviceType,
          this.state.id_servicio,
          this.state.customerCI,
          this.state.horas_minino_reserva
        );

        //var resp2 = await getHorasLibresByIdConsultorio(field_value, resp.dias[0].fecha, this.state.hora, this.state.token,  this.state.id_hora_original)

        if (field_value !== -1) {
          for (let key in this.state.consultorios) {
            if (this.state.consultorios[key].value === field_value) {
              zona = this.state.consultorios[key].zona;
              direccion = this.state.consultorios[key].direccion;
              latitud = this.state.consultorios[key].latitud;
              longitud = this.state.consultorios[key].longitud;
              consultorio = this.state.consultorios[key].consultorio;
            }
          }
        } else {
          zona = "";
          direccion = "";
          latitud = "";
          longitud = "";
          consultorio = "";
        }

        this.setState({
          ...this.state,
          dias: resp.dias,
          //horas_libres   : resp2.horas_libres,
          //fechaSelected  : resp.dias[0].fecha,
          //fechaLabel:resp.dias[0].label,
          id_consultorio: field_value,
          isExecuting: false,
          zona: zona,
          direccion: direccion,
          latitud: latitud,
          longitud: longitud,
          consultorio: consultorio,
          id_hora: 0,
          hora: "",
          validation2: respVal.validation,
        });
      } else {
        this.setState({
          ...this.state,
          hora: "",
          fechaSelected: "",
          id_hora: 0,
          dias: [],
          horas_libres: [],
          id_consultorio: "",
          isExecuting: false,
        });
      }
    } else if (field_name === "id_beneficiario") {
      var lock_ci = false;
      for (var i in this.state.Beneficiarios) {
        if (this.state.Beneficiarios[i].id_cliente === field_value) {
          if (this.state.Beneficiarios[i].ci_cliente !== "") {
            lock_ci = true;
          }

          var id_cliente = this.state.Beneficiarios[i].id_cliente;
          var ci_cliente = this.state.Beneficiarios[i].ci_cliente;
          var bloquear_datos = true;
          var nombre_cliente = this.state.Beneficiarios[i].nombre_cliente;
          var nombre_cliente2 =
            this.state.Beneficiarios[i].nombre_cliente2 || "";
          var TipoDoc = this.state.Beneficiarios[i].TipoDoc;
          var apellido_paterno = this.state.Beneficiarios[i].apellido_paterno;
          var apellido_materno = this.state.Beneficiarios[i].apellido_materno;
          var radioGenero = this.state.Beneficiarios[i].radioGenero;
          var telefono_cliente = this.state.Beneficiarios[i].telefono_cliente;
          var email_cliente = this.state.Beneficiarios[i].email_cliente;
          var FechaNaci = this.state.Beneficiarios[i].FechaNaci;
          var Tipo = this.state.Beneficiarios[i].Tipo;
          Id_afiliado = this.state.Beneficiarios[i].Id_afiliado;
          ci_afiliado = this.state.Beneficiarios[i].ci_afiliado;
          Tipo_doc_afiliado = this.state.Beneficiarios[i].Tipo_doc_afiliado;
        }
      }
      if (this.state.Id_afiliado === field_value) {
        Id_afiliado = "";
        ci_afiliado = "";
        Tipo_doc_afiliado = "";
      } else {
        Id_afiliado = this.state.Id_afiliado_original;
        ci_afiliado = this.state.ci_afiliado_original;
        Tipo_doc_afiliado = this.state.Tipo_doc_afiliado_original;
      }
      validation = [
        {
          name: "ci_cliente",
          label: "Carnet de Identidad",
          invalid: false,
          type: "number",
          notRequired: true,
        },
        {
          name: "nombre_cliente",
          label: "Primer Nombre",
          invalid: false,
          type: "text",
        },

        {
          name: "apellido_paterno",
          label: "Apellido Paterno",
          invalid: false,
          type: "text",
        },
        {
          name: "telefono_cliente",
          label:
            "Numero de Celular(Es necesario para enviarle las notificaciones)",
          invalid: false,
          type: "phone",
        },
        {
          name: "email_cliente",
          label: "Email",
          invalid: false,
          type: "email",
          notRequired: true,
        },
        {
          name: "day",
          label: "Dia de Nacimiento",
          invalid: false,
          type: "text",
        },
        {
          name: "month",
          label: "Mes de Nacimiento",
          invalid: false,
          type: "text",
        },
        {
          name: "year",
          label: "A\u00F1o de Nacimiento",
          invalid: false,
          type: "number",
        },
      ];
      this.setState({ ...this.state, validation: validation });
      this.setState({
        ...this.state,
        lock_ci: lock_ci,
        id_cliente: id_cliente,
        id_beneficiario: id_cliente,
        ci_cliente: ci_cliente,
        bloquear_datos: bloquear_datos,
        nombre_cliente: nombre_cliente,
        nombre_cliente2: nombre_cliente2 || "",
        TipoDoc: TipoDoc,
        apellido_paterno: apellido_paterno,
        apellido_materno: apellido_materno,
        radioGenero: radioGenero,
        telefono_cliente: telefono_cliente,
        email_cliente: email_cliente,
        year: FechaNaci ? FechaNaci.substr(0, 4) : "",
        month: FechaNaci ? FechaNaci.substr(4, 2) : "",
        day: FechaNaci ? FechaNaci.substr(6, 2) : "",
        Tipo: Tipo,
        Id_afiliado: Id_afiliado,
        ci_afiliado: ci_afiliado,
        Tipo_doc_afiliado: Tipo_doc_afiliado,
      });
    }
  };

  getHorasLibresByIdConsultorioL = async (fecha, hora, hora_larga, id_hora) => {
    //console.log("getHorasLibresByIdConsultorioL");
    this.setState({
      ...this.state,
      fechaSelected: fecha,
      isExecuting: true,
      hora: hora,
      hora_larga: hora_larga,
      id_hora: id_hora ? id_hora : 0,
      horas_libres: [],
    });

    let pos = this.state.dias.findIndex(function (item) {
      return item.fecha === fecha;
    });

    let horas_libres = this.state.dias[pos].horas;

    setTimeout(
      function () {
        this.setState({
          ...this.state,
          horas_libres: horas_libres,
          isExecuting: false,
        });
      }.bind(this),
      500
    );
  };

  registraReserva = async () => {
    //console.log("registraReserva", this.state);

    var respVal = validateForm(this.state.validation, this.state, toast);
    var isValid = respVal.isValid;

    this.setState({ ...this.state, validation: respVal.validation });
    if (isValid) {
      this.setState({ ...this.state, isExecuting: true });
      var resp = await registraReserva(
        this.state,
        this.state.token,
        this.state.tipo_transaccion === "Reservar" ? "ACTIVA" : "PRERESERVA"
      );

      if (resp.resp === "NOK") {
        toast.error(resp.desc, { closeButton: true });
        this.setState({ ...this.state, isExecuting: false });
      } else {
        toast.success(resp.desc, { closeButton: true });

        this.setState({
          ...this.state,
          consultorios: null,
          isExecuting: false,
          paymentKey: resp.llave,
          estado_reserva: true,
          reserva_editada: true,
          personal_meeting_url: resp.personal_meeting_url,
          activeItem: "1",
          showReservationForm: false,
        });

        if (this.state.tipo_transaccion === "Reservar") {
          this.setState({
            showEditReservationSucc: true,
          });
          //console.log("reservado!!!");
          var respM = enviarMail(resp.llave);
          var respW = enviarWsp(resp.llave);
          /*//var respS =  enviarSMS( resp.llave)*/
        } else {
          this.setState({
            showReservationSucc: true,
          });
        }
      }
    }
  };

  editaReserva = async () => {
    //console.log("editaReserva", this.state);
    var respVal = validateForm(this.state.validation, this.state, toast);
    var isValid = respVal.isValid;
    this.setState({ ...this.state, validation: respVal.validation });
    if (isValid) {
      this.setState({ ...this.state, isExecuting: true });
      let id_hora = -1;
      var respCanc = await cancelaReserva(this.state.token, id_hora);

      if (respCanc.resp === "NOK") {
        toast.error(resp.desc, { closeButton: true });
      } else {
        var resp = await registraReserva(
          this.state,
          this.state.token,
          "ACTIVA"
        );
        if (resp.resp === "NOK") {
          toast.error(resp.desc, { closeButton: true });
        } else {
          var respM = enviarMail(resp.llave);
          var respW = enviarWsp(resp.llave);
          //var resps =  enviarSMS( resp.llave)
          toast.success(resp.desc, { closeButton: true });

          this.setState({
            ...this.state,
            consultorios: null,
            estado_reserva: true,
            reserva_editada: true,
            paymentKey: resp.llave,
            personal_meeting_url: resp.personal_meeting_url,
            activeItem: "1",
            showReservationForm: false,
            showEditReservationSucc: true,
          });
        }
      }
      this.setState({ ...this.state, isExecuting: false });
    }
  };

  render() {
    return (
      <div>
        <div className="breadcrumb-bar">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-12 col-12">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/home">Inicio</Link>
                    </li>
                  </ol>
                </nav>
                <h2 className="breadcrumb-title">
                  Reserva de atenciones M&eacute;dicas
                </h2>
              </div>
            </div>
          </div>
        </div>

        <Loader idLoading={this.state.isExecuting} />
        <ToastContainer
          hideProgressBar={true}
          newestOnTop={false}
          position={"bottom-right"}
          autoClose={3000}
        />

        <Dialog
          open={this.state.modal1}
          icon="fas fa-ban"
          title="Reserva Fuera de tiempo"
          message="La reserva ya no se puede cambiar, expir&oacute; el tiempo m&aacute;ximo para realizar cambios"
          buttons={this.state.buttonsModalBack}
        />

        {this.state.goBack ? (
          <Redirect to={{ pathname: this.state.urlBack }} />
        ) : (
          ""
        )}

        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <MDBContainer className="mt-4">
                  {this.state.showReservationType ? (
                    <MDBRow className="mt-4">
                      <MDBCol
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                        className="text-right"
                      >
                        <MDBBtn
                          className="btn btn-block btn-primary submit-btn mt-1"
                          style={{ padding: "1.75rem", borderRadius: "1em" }}
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              showReservationType: false,
                              showReservationForm: true,
                              tipoReserva: "virtual",
                              id_ciudad: -1,
                              paso2: 1,
                              paso3: 2,
                              formActivePanel1: 2,
                            });
                            setTimeout(
                              function () {
                                this.changeHandler({
                                  target: { value: -1, name: "id_consultorio" },
                                });
                              }.bind(this),
                              10
                            );
                          }}
                        >
                          <MDBIcon icon="laptop-medical" size="3x" />{" "}
                          <span className="ml-2 h2"> CONSULTORIO VIRTUAL</span>
                        </MDBBtn>
                      </MDBCol>
                      <MDBCol
                        sm="12"
                        md="12"
                        lg="6"
                        xl="6"
                        className="text-left"
                      >
                        <MDBBtn
                          className="btn btn-block btn-primary submit-btn  mt-1"
                          style={{ padding: "1.75rem", borderRadius: "1em" }}
                          onClick={() => {
                            this.setState({
                              showReservationType: false,
                              showReservationForm: true,
                              tipoReserva: "presencial",
                              paso2: 2,
                              paso3: 3,
                              formActivePanel1: 1,
                              id_ciudad: "",
                              id_consultorio: "",
                            });
                          }}
                        >
                          <MDBIcon icon="user-md" size="3x" />{" "}
                          <span className="ml-2 h2">
                            {" "}
                            CONSULTORIO PRESENCIAL
                          </span>
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>
                  ) : (
                    ""
                  )}
                  {this.state.showReservationSucc ? (
                    <Redirect
                      to={{
                        pathname:
                          "/patient/checkout/atencion/" + this.state.paymentKey,
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {this.state.showEditReservationSucc ? (
                    <Redirect
                      to={{
                        pathname:
                          "/patient/booking-success/atencion/" +
                          this.state.paymentKey,
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {this.state.showReservationForm ? (
                    <MDBRow>
                      <MDBCol>
                        <MDBCard>
                          <MDBCardBody>
                            {this.state.formActivePanel1 === 3 ? (
                              <h4>Ingresa tus datos</h4>
                            ) : this.state.tipoReserva === "virtual" ? (
                              <h4>
                                <strong>
                                  Agenda tu Atenci&oacute;n M&eacute;dica
                                </strong>
                              </h4>
                            ) : (
                              <h4>
                                <strong>
                                  Agenda tu Atenci&oacute;n M&eacute;dica{" "}
                                </strong>
                              </h4>
                            )}
                            <MDBStepper form>
                              {this.state.tipoReserva === "virtual" ? (
                                ""
                              ) : (
                                <MDBStep form>
                                  <a href="#formstep1">
                                    <MDBBtn
                                      className={
                                        "btn btn-" +
                                        (this.state.formActivePanel1 === 1
                                          ? "primary"
                                          : "light") +
                                        " cbtn-circle"
                                      }
                                    >
                                      1
                                    </MDBBtn>
                                  </a>
                                </MDBStep>
                              )}
                              <MDBStep form>
                                <a href="#presencial">
                                  <MDBBtn
                                    className={
                                      "btn btn-" +
                                      (this.state.formActivePanel1 === 2
                                        ? "primary"
                                        : "light") +
                                      " cbtn-circle"
                                    }
                                  >
                                    {this.state.paso2}
                                  </MDBBtn>
                                </a>
                              </MDBStep>

                              <MDBStep form className="warning">
                                <a href="#formstep3">
                                  <MDBBtn
                                    className={
                                      "btn btn-" +
                                      (this.state.formActivePanel1 === 3
                                        ? "primary"
                                        : "light") +
                                      " cbtn-circle"
                                    }
                                  >
                                    {this.state.paso3}
                                  </MDBBtn>
                                </a>
                              </MDBStep>
                            </MDBStepper>
                            <MDBRow>
                              {this.state.formActivePanel1 === 1 && (
                                <MDBContainer>
                                  <div className="info-widget">
                                    <h4 className="card-title mt-4">
                                      Ingresa datos de tu atenci&oacute;n de
                                      salud
                                    </h4>
                                    <div className="row ">
                                      <div className="col-md-12 col-sm-12 mt-3">
                                        <div className="form-group card-label">
                                          <select
                                            id="id_ciudad"
                                            name="id_ciudad"
                                            defaultValue={this.state.id_ciudad}
                                            onChange={this.changeHandler}
                                            className={
                                              "form-control " +
                                              (this.state.validation2[0].invalid
                                                ? "is-invalid"
                                                : "")
                                            }
                                          >
                                            {this.state.ciudades.map((item) => (
                                              <option
                                                selected={
                                                  this.state.id_ciudad ===
                                                  item.value
                                                }
                                                key={"item" + item.value}
                                                value={item.value}
                                              >
                                                {item.text}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-12 col-sm-12 mt-3">
                                        <div className="form-group card-label">
                                          <select
                                            id="id_consultorio"
                                            defaultValue={
                                              this.state.id_consultorio
                                            }
                                            name="id_consultorio"
                                            onChange={this.changeHandler}
                                            className={
                                              "form-control " +
                                              (this.state.validation2[1].invalid
                                                ? "is-invalid"
                                                : "")
                                            }
                                          >
                                            {this.state.consultorios.map(
                                              (item) => (
                                                <option
                                                  selected={
                                                    this.state
                                                      .id_consultorio ===
                                                    item.value
                                                  }
                                                  key={"item" + item.value}
                                                  value={item.value}
                                                >
                                                  {item.text}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {this.state.disabledServiceType ? (
                                    <Link
                                      to={this.state.urlBack}
                                      className="btn btn-rounded cbtn-outline xxx"
                                    >
                                      atras
                                    </Link>
                                  ) : (
                                    <MDBBtn
                                      disabled={this.state.disabledServiceType}
                                      className="btn btn-rounded cbtn-outline yyy"
                                      onClick={() => {
                                        this.setState({
                                          ...this.state,
                                          tipoReserva: "",
                                          showReservationType: true,
                                          showReservationForm: false,
                                          paso2: "2",
                                          paso3: "3",
                                          id_hora: 0,
                                          fechaSelected: "",
                                          horas_libres: [],
                                          fecha: "",
                                          consultorio: "",
                                          ciudad: "",
                                          consultorios: [],
                                        });
                                      }}
                                    >
                                      anterior
                                    </MDBBtn>
                                  )}

                                  <MDBBtn
                                    className="btn btn-rounded btn-primary float-right"
                                    onClick={this.handleNextPrevClick(1)(2)}
                                  >
                                    siguiente
                                  </MDBBtn>
                                </MDBContainer>
                              )}
                              {this.state.formActivePanel1 === 2 && (
                                <MDBContainer className="justify-content-left">
                                  <div className="info-widget">
                                    <h4
                                      style={{ height: 38 }}
                                      className={"card-title mt-4 "}
                                    >
                                      {this.state.mensaje_seleccione_fechahora}
                                    </h4>
                                    <small className="font-italic">
                                      *Puedes realizar la reserva hasta con{" "}
                                      {this.state.dias_max_reserva} dias de
                                      anticipaci&oacute;n
                                    </small>
                                    <div className="card booking-schedule schedule-widget">
                                      <div className="schedule-header">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="day-slot">
                                              <ul
                                                className={
                                                  "clearfix" +
                                                  (this.state.dias.length > 1
                                                    ? " visible"
                                                    : "")
                                                }
                                              >
                                                {this.state.dias.map((item) => (
                                                  <>
                                                    {this.state.from_fecha <=
                                                      item.i &&
                                                    this.state.to_fecha >=
                                                      item.i ? (
                                                      <>
                                                        {this.state
                                                          .from_fecha ===
                                                        item.i ? (
                                                          <li
                                                            key="liarrowLeft"
                                                            className="left-arrow"
                                                          >
                                                            <Link
                                                              key="arrowLeft"
                                                              to="#"
                                                              onClick={() => {
                                                                if (
                                                                  this.state
                                                                    .from_fecha >
                                                                  0
                                                                ) {
                                                                  var newFrom =
                                                                    this.state
                                                                      .from_fecha -
                                                                    7;
                                                                  var newTo =
                                                                    this.state
                                                                      .to_fecha -
                                                                    7;
                                                                  this.setState(
                                                                    {
                                                                      from_fecha:
                                                                        newFrom,
                                                                      to_fecha:
                                                                        newTo,
                                                                      horas_libres:
                                                                        [],
                                                                      id_hora: 0,
                                                                      hora: "",
                                                                      fechaSelected:
                                                                        "",
                                                                    }
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <i className="fa fa-chevron-left"></i>
                                                            </Link>
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                        <li
                                                          key={"li" + item.key}
                                                        >
                                                          <Link
                                                            key={item.key}
                                                            className={
                                                              "day " +
                                                              (item.esReservada
                                                                ? "selected"
                                                                : this.state
                                                                    .fechaSelected ===
                                                                  item.fecha
                                                                ? "selected"
                                                                : "")
                                                            }
                                                            to="#0"
                                                            onClick={() => {
                                                              if (
                                                                item.fecha !=
                                                                this.state
                                                                  .fechaSelected
                                                              ) {
                                                                this.getHorasLibresByIdConsultorioL(
                                                                  item.fecha
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            <span>
                                                              {item.dia}
                                                            </span>{" "}
                                                            <span>
                                                              {item.label}
                                                            </span>
                                                          </Link>
                                                        </li>
                                                        {this.state.to_fecha ===
                                                        item.i ? (
                                                          <li
                                                            key="liarrowRight"
                                                            className="right-arrow"
                                                          >
                                                            <Link
                                                              to="#"
                                                              key="arrowRight"
                                                              onClick={() => {
                                                                if (
                                                                  this.state
                                                                    .to_fecha <
                                                                  this.state
                                                                    .dias_max_reserva -
                                                                    8
                                                                ) {
                                                                  var newFrom =
                                                                    this.state
                                                                      .from_fecha +
                                                                    7;
                                                                  var newTo =
                                                                    this.state
                                                                      .to_fecha +
                                                                    7;
                                                                  this.setState(
                                                                    {
                                                                      from_fecha:
                                                                        newFrom,
                                                                      to_fecha:
                                                                        newTo,
                                                                      horas_libres:
                                                                        [],
                                                                      id_hora: 0,
                                                                      hora: "",
                                                                      fechaSelected:
                                                                        "",
                                                                    }
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <i className="fa fa-chevron-right"></i>
                                                            </Link>
                                                          </li>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </>
                                                ))}
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="schedule-cont">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="time-slot">
                                              <ul
                                                className={
                                                  "clearfix" +
                                                  (this.state.horas_libres
                                                    .length > 1
                                                    ? " visible"
                                                    : "")
                                                }
                                              >
                                                {this.state.horas_libres.map(
                                                  (item) => (
                                                    <li>
                                                      <Link
                                                        className={
                                                          this.state.hora ===
                                                          item.hora
                                                            ? "timing selected"
                                                            : item.esReservada
                                                            ? "timing locked"
                                                            : "timing "
                                                        }
                                                        to="#0"
                                                        key={
                                                          "horaLnk" + item.key
                                                        }
                                                        onClick={() => {
                                                          if (
                                                            this.state.hora ===
                                                              item.hora ||
                                                            item.esReservada
                                                          ) {
                                                            return;
                                                          } else {
                                                            this.setState({
                                                              ...this.state,
                                                              hora: item.hora,
                                                              hora_larga:
                                                                item.hora,
                                                              id_hora:
                                                                item.id_hora,
                                                              modal3: true,
                                                            });
                                                          }
                                                        }}
                                                      >
                                                        <span>
                                                          {item.hora}{" "}
                                                        </span>
                                                      </Link>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.tipoReserva === "virtual" ? (
                                    <>
                                      {this.state.disabledServiceType ? (
                                        <Link
                                          to={this.state.urlBack}
                                          className="btn btn-rounded cbtn-outline"
                                        >
                                          atras
                                        </Link>
                                      ) : (
                                        <MDBBtn
                                          disabled={
                                            this.state.disabledServiceType
                                          }
                                          className="btn btn-rounded cbtn-outline"
                                          onClick={() => {
                                            this.setState({
                                              ...this.state,
                                              tipoReserva: "",
                                              showReservationType: true,
                                              showReservationForm: false,
                                              paso2: "2",
                                              paso3: "3",
                                              id_hora: 0,
                                              fechaSelected: "",
                                              horas_libres: [],
                                              fecha: "",
                                              consultorio: "",
                                              ciudad: "",
                                              consultorios: [],
                                            });
                                          }}
                                        >
                                          anterior
                                        </MDBBtn>
                                      )}
                                    </>
                                  ) : (
                                    <MDBBtn
                                      className="btn btn-rounded cbtn-outline"
                                      onClick={this.handleNextPrevClick(1)(1)}
                                      autoFocus={this.calculateAutofocus(1)}
                                    >
                                      anterior
                                    </MDBBtn>
                                  )}
                                  <MDBBtn
                                    className="btn btn-rounded btn-primary float-right"
                                    onClick={this.handleNextPrevClick(1)(3)}
                                    autoFocus={this.calculateAutofocus(1)}
                                  >
                                    siguiente
                                  </MDBBtn>
                                </MDBContainer>
                              )}
                              {this.state.formActivePanel1 === 3 && (
                                <MDBContainer className="mt-4">
                                  <div className="info-widget">
                                    <div
                                      className="alert alert-secondary alert-dismissible fade show"
                                      role="alert"
                                    >
                                      Por favor complete los datos del paciente.
                                    </div>
                                    {this.state.Beneficiarios.length > 1 ? (
                                      <>
                                        <div className="row">
                                          <div className="col-md-6 col-sm-12">
                                            <div className="form-group card-label">
                                              <strong>
                                                <span
                                                  style={{ color: "#757575" }}
                                                >
                                                  Usted puede
                                                  seleccionar/cambiar al
                                                  paciente
                                                </span>
                                              </strong>
                                              <select
                                                disabled={
                                                  this.state.look_agregar
                                                }
                                                id="id_beneficiario"
                                                name="id_beneficiario"
                                                value={
                                                  this.state.id_beneficiario
                                                }
                                                defaultValue={
                                                  this.state.id_beneficiario
                                                }
                                                onChange={this.changeHandler}
                                                className="form-control mt-1"
                                              >
                                                {this.state.Beneficiarios.map(
                                                  (item) => (
                                                    <option
                                                      key={
                                                        "itemB" +
                                                        item.id_cliente
                                                      }
                                                      value={item.id_cliente}
                                                    >
                                                      {this.state
                                                        .id_beneficiario +
                                                        "." +
                                                        item.nombre_cliente +
                                                        " " +
                                                        item.apellido_paterno +
                                                        " " +
                                                        item.apellido_materno}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="row"
                                          style={{ marginTop: -15 }}
                                        >
                                          <div className="col-md-6 col-sm-12">
                                            <MDBBtn
                                              className="btn btn-warning btm-sm float-right"
                                              onClick={() => {
                                                if (this.state.look_agregar) {
                                                  this.setPatientData();
                                                } else {
                                                  var id_cliente_cur =
                                                    this.state.id_cliente;
                                                  this.setState({
                                                    id_cliente_cur:
                                                      id_cliente_cur,
                                                    look_agregar: true,
                                                    bloquear_datos: false,
                                                    lock_ci: false,
                                                    ci_cliente: "",
                                                    nombre_cliente: "",
                                                    nombre_cliente2: "",
                                                    apellido_paterno: "",
                                                    apellido_materno: "",
                                                    day: "",
                                                    month: "",
                                                    year: "",
                                                  });
                                                }
                                              }}
                                            >
                                              <MDBIcon
                                                icon="check"
                                                className="ml-1"
                                              />
                                              {!this.state.look_agregar
                                                ? "Agregar paciente"
                                                : "Cancelar"}
                                            </MDBBtn>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <div className="row">
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Carnet de Identidad </label>
                                          <input
                                            className={
                                              "form-control " +
                                              (this.state.validation[0]
                                                .invalid == true
                                                ? "is-invalid"
                                                : "")
                                            }
                                            type="text"
                                            name="ci_cliente"
                                            value={this.state.ci_cliente}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Primer Nombre *</label>
                                          <input
                                            disabled={this.state.bloquear_datos}
                                            className={
                                              "form-control " +
                                              (this.state.validation[1].invalid
                                                ? "is-invalid"
                                                : "")
                                            }
                                            type="text"
                                            name="nombre_cliente"
                                            value={this.state.nombre_cliente}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Segundo Nombre</label>
                                          <input
                                            disabled={this.state.bloquear_datos}
                                            className={"form-control "}
                                            type="text"
                                            name="nombre_cliente2"
                                            value={this.state.nombre_cliente2}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Apellido Paterno *</label>
                                          <input
                                            disabled={this.state.bloquear_datos}
                                            className={
                                              "form-control " +
                                              (this.state.validation[2].invalid
                                                ? "is-invalid"
                                                : "")
                                            }
                                            type="text"
                                            name="apellido_paterno"
                                            value={this.state.apellido_paterno}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Apellido Materno</label>
                                          <input
                                            disabled={this.state.bloquear_datos}
                                            className={"form-control"}
                                            type="text"
                                            name="apellido_materno"
                                            value={this.state.apellido_materno}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <span
                                            className="ml-2"
                                            style={{ color: "#757575" }}
                                          >
                                            Sexo del paciente
                                          </span>
                                          <MDBFormInline>
                                            <label className="ml-2">
                                              <input
                                                type="radio"
                                                name="radioGenero"
                                                checked={
                                                  this.state.radioGenero !== 1
                                                    ? true
                                                    : false
                                                }
                                                onClick={this.onClickRadio(0)}
                                              />
                                              <span className="checkmark ml-1">
                                                Mujer
                                              </span>
                                            </label>
                                            <label className="ml-2">
                                              <input
                                                type="radio"
                                                name="radioGenero"
                                                checked={
                                                  this.state.radioGenero === 1
                                                    ? true
                                                    : false
                                                }
                                                onClick={this.onClickRadio(1)}
                                              />
                                              <span className="checkmark ml-1">
                                                Hombre
                                              </span>
                                            </label>
                                          </MDBFormInline>
                                        </div>
                                      </div>

                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <span
                                            className="ml-2"
                                            style={{ color: "#757575" }}
                                          >
                                            Fecha de Nacimiento
                                          </span>
                                          <MDBFormInline>
                                            <label className="ml-2">
                                              <select
                                                defaultValue={this.state.day}
                                                style={{ padding: "0px 0px" }}
                                                id="day"
                                                name="day"
                                                onChange={this.changeHandler}
                                                className={
                                                  "form-control " +
                                                  (this.state.validation[5]
                                                    .invalid
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                {this.state.v_days.map(
                                                  (item) => (
                                                    <option
                                                      selected={
                                                        item.value ==
                                                        this.state.day
                                                          ? true
                                                          : false
                                                      }
                                                      value={item.value}
                                                    >
                                                      {item.text}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </label>
                                            <label className="ml-2">
                                              <select
                                                defaultValue={this.state.month}
                                                style={{ padding: "0px 0px" }}
                                                id="month"
                                                name="month"
                                                onChange={this.changeHandler}
                                                className={
                                                  "form-control " +
                                                  (this.state.validation[6]
                                                    .invalid
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                {this.state.v_months.map(
                                                  (item) => (
                                                    <option
                                                      selected={
                                                        item.value ==
                                                        this.state.month
                                                          ? true
                                                          : false
                                                      }
                                                      value={item.value}
                                                    >
                                                      {item.text}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </label>
                                            <label className="ml-2">
                                              <select
                                                defaultValue={this.state.year}
                                                style={{ padding: "0px 0px" }}
                                                id="year"
                                                name="year"
                                                onChange={this.changeHandler}
                                                className={
                                                  "form-control " +
                                                  (this.state.validation[7]
                                                    .invalid
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                              >
                                                {this.state.v_years.map(
                                                  (item) => (
                                                    <option
                                                      selected={
                                                        item.value ==
                                                        this.state.year
                                                          ? true
                                                          : false
                                                      }
                                                      value={item.value}
                                                    >
                                                      {item.text}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </label>
                                          </MDBFormInline>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>
                                            N&uacute;mero de Celular *
                                          </label>
                                          <input
                                            className={
                                              "form-control " +
                                              (this.state.validation[3]
                                                .invalid == true
                                                ? "is-invalid"
                                                : "")
                                            }
                                            type="text"
                                            name="telefono_cliente"
                                            value={this.state.telefono_cliente}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6 col-sm-12">
                                        <div className="form-group card-label">
                                          <label>Email</label>
                                          <input
                                            className={
                                              "form-control " +
                                              (this.state.validation[4]
                                                .invalid == true
                                                ? "is-invalid"
                                                : "")
                                            }
                                            type="text"
                                            name="email_cliente"
                                            value={this.state.email_cliente}
                                            onChange={this.changeHandler}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    {this.state.tipoReserva === "virtual" ? (
                                      <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                          <div className="form-group card-label">
                                            <span
                                              className="ml-2"
                                              style={{ color: "#757575" }}
                                            >
                                              Selecciona el medio de
                                              comunicaci&oacute;n de tu
                                              preferencia para recibir tu
                                              atenci&oacute;n m&eacute;dica
                                            </span>
                                            <br></br>
                                            <label className="ml-1">
                                              <input
                                                type="radio"
                                                name="radioTipoReunionVirtual"
                                                checked={
                                                  this.state
                                                    .radioTipoReunionVirtual ===
                                                  1
                                                    ? true
                                                    : false
                                                }
                                                onClick={this.onClickRadio2(1)}
                                              />
                                              <span className="checkmark ml-1">
                                                <img
                                                  className="checkmark mr-2"
                                                  src={`data:image/jpeg;base64,${this.state.zoomImg}`}
                                                />
                                                Reuni&oacute;n por Zoom
                                                (Recomendado - te enviaremos el
                                                enlace para la cita a realizarse
                                                en la fecha y hora registrada)
                                              </span>
                                            </label>
                                            <label className="ml-1">
                                              <input
                                                type="radio"
                                                name="radioTipoReunionVirtual"
                                                checked={
                                                  this.state
                                                    .radioTipoReunionVirtual ===
                                                  0
                                                    ? true
                                                    : false
                                                }
                                                onClick={this.onClickRadio2(0)}
                                              />
                                              <span className="checkmark ml-1">
                                                <img
                                                  alt="whastapp"
                                                  className="checkmark mr-2"
                                                  src={`data:image/jpeg;base64,${this.state.whatsImg}`}
                                                />
                                                Llamada WhatsApp (Videollamada
                                                por WhatsApp. Nosotros te
                                                llamaremos al n&uacute;mero
                                                registrado)
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <small className="font-italic ml-2">
                                      Los campos (*) son obligatorios
                                    </small>
                                  </div>
                                  <MDBBtn
                                    className="btn btn-rounded cbtn-outline"
                                    onClick={this.handleNextPrevClick(1)(2)}
                                    autoFocus={this.calculateAutofocus(1)}
                                  >
                                    anterior
                                  </MDBBtn>
                                  <MDBBtn
                                    className="btn btn-rounded btn-primary float-right"
                                    onClick={() => {
                                      if (
                                        this.state.estado_formulario ===
                                        "editar"
                                      ) {
                                        this.editaReserva();
                                      } else {
                                        this.registraReserva();
                                      }
                                    }}
                                  >
                                    <MDBIcon icon="check" className="ml-1" />
                                    {this.state.tipo_transaccion}
                                  </MDBBtn>
                                </MDBContainer>
                              )}
                            </MDBRow>
                          </MDBCardBody>
                        </MDBCard>
                        <hr />
                        <ul className="mt-2">
                          <li>
                            <small> {this.state.mensaje_soporte_tecnico}</small>
                          </li>
                          <li>
                            <small>
                              {" "}
                              {this.state.mensaje_confidencialidad}
                            </small>
                          </li>
                        </ul>
                      </MDBCol>
                    </MDBRow>
                  ) : (
                    ""
                  )}
                </MDBContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Booking;
